import { deepEquals } from 'app/infrastructure/js';
import { ComplexValue } from 'app/types-shared';
import { FavouriteItem, CompareFieldsData } from '../types-store';

const compareValues = (values: ComplexValue<number>[], originalValues: ComplexValue<number>[]): boolean => {
  const current = values || [];
  const original = originalValues || [];

  if (current.length !== original.length) {
    return true;
  }

  return current.some(
    value => !original.some(
      originalValue => value.value === originalValue.value
    ));
};

export const compareFields = <T>(data: CompareFieldsData<T>) => {
  const { fields, values, originalValues } = data;

  const newValues = values?.filter(value =>
    fields
      .map(field => value[field])
      .some(item => !!item) && value);

  return !deepEquals(newValues, originalValues);
};

export const hasChanges = (item?: FavouriteItem, original?: FavouriteItem): boolean => {

  const compare = item?.id !== original?.id ||
    item?.parent?.value !== original?.parent?.value ||
    item?.disabled?.getTime() !== original?.disabled?.getTime() ||
    item?.favouriteType?.value !== original?.favouriteType?.value ||
    item?.scheduleOwner?.value !== original?.scheduleOwner?.value ||
    compareValues(item?.owners, original?.owners) ||
    compareValues(item?.sharedWithUserGroups, original?.sharedWithUserGroups) ||
    compareValues(item?.sharedWithUsers, original?.sharedWithUsers) ||
    item?.emailSubscribers !== original?.emailSubscribers;

  if (compare) {
    return true;
  }

  const language = ((item ?? {}).language ?? [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);
  const originalLanguage = ((original || {}).language || [])
    .filter(languageItem => (languageItem.description ?? '').trim().length > 0);

  if (language.length !== originalLanguage.length) {
    return true;
  }

  if (language.some(
    languageItem => !originalLanguage.some(
      originalLanguageItem => (languageItem.value ?? '') === (originalLanguageItem.value ?? '') &&
        (languageItem.description ?? '') === (originalLanguageItem.description ?? ''))
  )) {
    return true;
  }

  const longDescription = ((item ?? {}).longDescription ?? [])
    .filter(longDescriptionItem => (longDescriptionItem.description ?? '').trim().length > 0);
  const originallongDescription = ((original || {}).longDescription || [])
    .filter(longDescriptionItem => (longDescriptionItem.description ?? '').trim().length > 0);

  if (longDescription.length !== originallongDescription.length) {
    return true;
  }

  if (longDescription.some(
    longDescriptionItem => !originallongDescription.some(
      originalLongDescriptionItem => (longDescriptionItem.value ?? '') === (originalLongDescriptionItem.value ?? '') &&
        (longDescriptionItem.description ?? '') === (originalLongDescriptionItem.description ?? ''))
  )) {
    return true;
  }

  return false;
};
